import React, { useState } from 'react';
import { FileSpreadsheet, Download, Loader } from 'lucide-react';
import { useNotifications } from '../../context/NotificationContext';
import api from '../../services/api';

const PowerQueryPage = () => {
  const { notify } = useNotifications();
  const [generating, setGenerating] = useState(false);

  const handleGenerate = async () => {
    setGenerating(true);

    try {
      const response = await api.get('/api/projectexport/generate', {
        responseType: 'blob'
      });

      // Extract filename from Content-Disposition header or use default
      const contentDisposition = response.headers['content-disposition'];
      let fileName = `PMD_Power_Query_${new Date().toISOString().slice(0, 10).replace(/-/g, '')}.xlsx`;

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^";\n]+)"?/i);
        if (match) {
          fileName = match[1];
        }
      }

      // Create download link
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      notify.success('Power Query export generated successfully');
    } catch (err) {
      console.error('Export failed:', err);
      notify.error('Failed to generate export: ' + (err.response?.data?.error || err.message));
    } finally {
      setGenerating(false);
    }
  };

  return (
    <div className="dev-module power-query-page">
      <div className="dev-module-header">
        <div className="dev-module-header-left">
          <h1>
            <FileSpreadsheet size={20} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
            Power Query
          </h1>
          <span className="dev-module-meta">9 views</span>
        </div>
      </div>

      <div className="dev-module-content">
        <div className="import-steps-layout">
          <div className="import-step-panel">
            <div className="import-step-header">
              <span className="import-step-number">1</span>
              <h3>Generate Export</h3>
            </div>
            <p className="import-step-desc">
              Generate Excel workbook with project data from 9 database views.
              Each view becomes a separate tab in the workbook.
            </p>

            <button
              className="import-generate-btn"
              onClick={handleGenerate}
              disabled={generating}
            >
              {generating ? (
                <>
                  <Loader size={16} className="spinning" />
                  Generating...
                </>
              ) : (
                <>
                  <Download size={16} />
                  Generate Export
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PowerQueryPage;
